export default {"src":"/_next/static/media/bucket-hat.2bd30566.svg","height":96,"width":104,"blurWidth":0,"blurHeight":0};